import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoStar = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Star</title>
    <path
      d="M15.486 6.085a.571.571 0 0 1 1.025 0l3.05 6.178a.572.572 0 0 0 .43.313l6.817.99a.571.571 0 0 1 .317.975l-4.934 4.81a.571.571 0 0 0-.164.505l1.165 6.79a.571.571 0 0 1-.83.603l-6.097-3.206a.572.572 0 0 0-.532 0l-6.099 3.206a.571.571 0 0 1-.829-.603l1.165-6.79a.572.572 0 0 0-.164-.506l-4.934-4.809a.571.571 0 0 1 .317-.974l6.818-.991a.572.572 0 0 0 .43-.313l3.05-6.178Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoStar;
